import { useState } from "react"
import { githubAuth } from "@/lib/http/auth"
import { useToast } from "@/hooks/useToast"

export function useGitHubAuth() {
  const [isLoading, setIsLoading] = useState(false)
  const { toast } = useToast()

  const handleGitHubAuth = async () => {
    try {
      setIsLoading(true)
      const { url } = await githubAuth()

      if (url) {
        // Redirect to GitHub OAuth
        window.location.href = url
      } else {
        toast({
          title: "Authentication Error",
          description: "Cannot access GitHub. Please try again later.",
          variant: "destructive",
        })
      }
    } catch (error) {
      console.error("GitHub auth error:", error)
      toast({
        title: "Authentication Error",
        description: "GitHub login is currently unavailable. Please try again later.",
        variant: "destructive",
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    handleGitHubAuth,
    isLoading,
  }
}
